import { Routes, RouterModule } from '@angular/router';
import { NgModule } from '@angular/core';

import { VendorsResolverService } from '../_shared/_resolvers/vendors-resolver.service';

const routes: Routes = [
  {
    path: '',
    loadComponent: async () => import('./pool-care.component').then(m => m.PoolCareComponent),
    resolve: {
      vendors: VendorsResolverService
    },
    data: { title: 'Pool Care Supplies' }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PoolCareRoutingModule { }
